import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ActivitySchedule from './activity-schedule';
import ActivityScheduleDetail from './activity-schedule-detail';
import ActivityScheduleUpdate from './activity-schedule-update';
import ActivityScheduleDeleteDialog from './activity-schedule-delete-dialog';

const ActivityScheduleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ActivitySchedule />} />
    <Route path="new" element={<ActivityScheduleUpdate />} />
    <Route path=":id">
      <Route index element={<ActivityScheduleDetail />} />
      <Route path="edit" element={<ActivityScheduleUpdate />} />
      <Route path="delete" element={<ActivityScheduleDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ActivityScheduleRoutes;
